import React, { useEffect, useMemo, useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Input, Select } from '../../../../../../../_metronic/_partials/controls';
import * as requestFt from '../../../../../MasterData/_redux/fund_type/fundtypeCrud';
import * as requestBank from '../../../../../MasterData/_redux/bank/bankCrud';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../../../_metronic/_partials/controls';
import { Table } from 'react-bootstrap';
import { getBankPoolingAll } from '../../../../../MasterData/_redux/bank-pooling/bankPoolingCrud';
import moment from 'moment';

import { Form as Forms } from 'react-bootstrap';
import * as requestProg from "../../../../../MasterData/_redux/program/programCrud";
import * as requestProj from "../../../../../MasterData/_redux/projects/projectsCrud";
import { getKurbanList } from "../../../../_redux/donation/donationCrud";
import { useReconcileEditUIContext } from "../ReconcileEditUIContext";
import CurrencyInput from 'react-currency-input-field';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { getBankAccountAll } from '../../../../../MasterData/_redux/bank-account/bankAccountCrud';



export const ReconcileEditForm = ({
    reconcile, btnCreateSettleRef, createSettleReconcile, amount,
    reconcileData, editDraftReconcile, id, status, setSubmitValue,
    handleClickOpenDialogSettle, btnEditDraftRef, createDraftReconcile, btnCreateDraftRef,
    btnEditSettleRef, editSettleReconcile, buttonType, setButtonType, setBankAccount, bankAccount,
    handleShow, setModalDisplay,
}) => {
    const [bankAccountOpt, setBankAccountOpt] = useState([]);
    const [bankPoolingList, setBankPoolingList] = useState([])


    let initialValues = null
    id &&
      reconcileData &&
      (initialValues = {
        bank_account_uuid: reconcileData.bank_account_uuid,
        diff_description: reconcileData.diff_description,
        channel_charge: reconcileData.channel_charge,
        file: "",
        amount: reconcileData.amount,
        trx_date: reconcileData.trx_date,
        bank_amount:
          Number(reconcileData.amount) - Number(reconcileData.channel_charge),
        diff_amount: reconcileData.diff_amount,
      });

    useEffect(() => {
        const fetchBankAccount = async () => {
            const result = await getBankAccountAll();
            setBankAccountOpt(result.data.data);
        };
        fetchBankAccount();
        // const fetchBank = async () => {
        //     const result = await requestBank.getBankAll();
        //     setBank(result.data.data);
        // };
        // fetchBank();

        const fetchBankPooling = async () => {
            const result = await getBankPoolingAll();
            setBankPoolingList(result.data.data);
        };
        fetchBankPooling()
    }, [reconcileData]);
    const ReconcileSchema = Yup.object().shape({
        // file: !id ? Yup.mixed().required('Bukti transfer wajib diisi') : Yup.mixed().notRequired(),
        bank_account_uuid: Yup.string().required('Bank Account wajib diisi'),
        // diff_description: Yup.string().required('Deskripsi wajib diisi'),
        // channel_charge: Yup.number().required('Selisih wajib diisi'),
        // amount: Yup.number().required('Nominal wajib diisi'),
        trx_date: Yup.string().required('tanggal transaksi wajib diisi'),
        // bank_amount: Yup.number().required('Nominal Bank wajib diisi'),
        // diff_amount: Yup.number().min(0, "Selisih Nominal Harus 0").max(0, "Selisih Nominal Harus 0").required('Jumlah wajib diisi'),

    });
    // console.log(kodeRek);





    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues || reconcile}
                validationSchema={ReconcileSchema}
                onSubmit={(values) => {
                    values.amount = amount
                    // id ? editDraftReconcile(values) : createSettleReconcile(values);
                    setSubmitValue(values)
                    switch (buttonType) {
                        case "edit_draft":
                            editDraftReconcile(values)
                            break;
                        case "edit_settle":
                            handleClickOpenDialogSettle()
                            break;
                        case "create_settle":
                            handleClickOpenDialogSettle()
                            break;
                        case "create_draft":
                            createDraftReconcile(values)
                            break;
                        default:
                            break;
                    }
                    // if (buttonType === "create_settle") {
                    //     handleClickOpenDialogSettle()

                    // }
                }}>
                {({ handleSubmit, setFieldValue, handleChange, values, setValues }) => (
                    <>
                        <Form className="form form-label-right">
                            <div className="form-group row">
                                <div className="col-lg mb-4 ">
                                    <label htmlFor="trx_date">Tanggal Transaksi</label>
                                    <TextField
                                        id="trx_date"
                                        type="date"
                                        name="trx_date"
                                        className="form-control"
                                        value={values.trx_date}
                                        onChange={(e) => {
                                            setFieldValue('trx_date', moment(e.target.value).format('YYYY-MM-DD'))
                                        }}
                                        disabled={status === "SETTLE"}
                                    />
                                    <ErrorMessage name='trx_date'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>}
                                    />
                                </div>
                                <div className="col-lg mb-2">
                                    <label htmlFor="amount">Bank Account</label>
                                    {
                                        id ? <Autocomplete
                                            name="bank_account_uuid"
                                            options={bankAccountOpt}
                                            // defaultValue={reconcileData.uuid && { uuid: reconcileData.bank_pooling.uuid }}
                                            value={bankAccountOpt.length > 0 && bankAccountOpt.find((item) => item.uuid === values.bank_account_uuid)}
                                            getOptionLabel={(option) => {
                                                const label = `${option.bank &&
                                                  option.bank.name} - ${
                                                  option.account_number
                                                }`;
                                                return label;
                                            }}
                                            onChange={(e, value) => {
                                                if (value) {
                                                    setFieldValue("bank_account_uuid", value.uuid)
                                                    setBankAccount(value.uuid)
                                                } else {
                                                    setFieldValue("bank_account_uuid", "")
                                                    setBankAccount(null)
                                                }
                                            }}
                                            disabled={status === "SETTLE"}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Cari Bank Account"
                                                    variant="outlined"
                                                    // disableClearable
                                                    size="small"

                                                />
                                            )}
                                        /> :
                                            <Autocomplete
                                                name="bank_account_uuid"
                                                options={bankAccountOpt}
                                                // defaultValue={reconcileData.uuid && { uuid: reconcileData.bank_pooling.uuid }}

                                                getOptionLabel={(option) => {
                                                    const label = `${option.bank &&
                                                    option.bank.name} - ${
                                                    option.account_number
                                                    }`;
                                                    return label;
                                                }}
                                                onChange={(e, value) => {
                                                    if (value) {
                                                        setFieldValue("bank_account_uuid", value.uuid)
                                                        setBankAccount(value.uuid)
                                                    } else {
                                                        setFieldValue("bank_account_uuid", "")
                                                        setBankAccount(null)

                                                    }
                                                }}
                                                disabled={status === "SETTLE"}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Cari Bank Account"
                                                        variant="outlined"
                                                        // disableClearable
                                                        size="small"

                                                    />
                                                )}
                                            />
                                    }

                                    <ErrorMessage name='bank_account_uuid'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>}
                                    />

                                </div>
                                {/* <div className="col-lg mb-2">
                                    <label htmlFor="amount">Tambahkan Payment</label>
                                    <button
                                        type="button"
                                        className="btn btn-success mr-2 form-control"
                                        onClick={() => {
                                            handleShow()
                                            setModalDisplay("DONASI")
                                        }}
                                        disabled={(status === "SETTLE" || !bankPooling)}

                                    >
                                        <i className="fa fa-plus"></i>
                                        Tambah Payment
                                    </button>
                                </div> */}

                                {/* <div className="col-lg mb-2">
                                    <label htmlFor="amount">Grand Total</label>
                                    <CurrencyInput
                                        name="amount"
                                        placeholder="Nominal"
                                        intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                        className="form-control"
                                        decimalsLimit={2}
                                        label="Jumlah"
                                        value={amount}
                                        disabled={true}
                                    // change
                                    />
                                    <ErrorMessage name='amount'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>}
                                    />
                                </div> */}

                            </div>


                            {/* <div className="form-group row">


                                <div className="col-lg">
                                    <label htmlFor="bank_amount">Input Dana Masuk</label>
                                    <CurrencyInput
                                        name="bank_amount"
                                        placeholder="Nominal Pada Bank/EDC"
                                        intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                        className="form-control"
                                        // defaultValue={Number(values.amount) + Number(values.channel_charge)}
                                        value={values.bank_amount}
                                        decimalsLimit={2}
                                        label="Jumlah"
                                        disabled={status === "SETTLE"}
                                        onValueChange={(value, name) => {
                                            setFieldValue(name, value)
                                            let difference = Number(amount) - (Number(values.channel_charge) + Number(value))
                                            setFieldValue("diff_amount", difference)


                                        }}
                                    />
                                    <ErrorMessage name='bank_amount'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>}
                                    />
                                </div>
                                <div className="col-lg">
                                    <label htmlFor="channel_charge">Input Biaya Channel</label>
                                    <CurrencyInput
                                        disabled={status === "SETTLE"}
                                        name="channel_charge"
                                        placeholder="Nominal Pada Bank/EDC"
                                        intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                        className="form-control"
                                        defaultValue={0}
                                        value={values.channel_charge}
                                        decimalsLimit={2}
                                        label="Jumlah"
                                        onValueChange={(value, name) => {
                                            setFieldValue(name, value)
                                            let difference = Number(amount) - (Number(values.bank_amount) + Number(value))
                                            setFieldValue("diff_amount", difference)


                                        }}
                                    />
                                    <ErrorMessage name='channel_charge'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>}
                                    />
                                </div>

                                <div className="col-lg">
                                    <label htmlFor="diff_amount">Selisih Nominal</label>
                                    <CurrencyInput
                                        name="diff_amount"
                                        placeholder="Selisih Nominal"
                                        intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                        className="form-control"
                                        // defaultValue={values.goods_qty_price ?? ""}
                                        value={values.diff_amount}
                                        decimalsLimit={2}
                                        label="Jumlah"
                                        // onValueChange={(value, name) => {
                                        //     setFieldValue(name, value)

                                        // }}
                                        // value={Number(values.bank_amount) > 0 ? (amount - values.bank_amount) : 0}
                                        disabled={true}
                                    />
                                    <ErrorMessage name='diff_amount'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>}
                                    />
                                </div>
                            </div> */}
                            <div className="form-group row">
                                <div className="col-lg">
                                    <label htmlFor="diff_description">Deskripsi Selisih</label>
                                    <Field
                                        id="diff_description"

                                        name="diff_description"
                                        className="form-control"
                                        disabled={status === "SETTLE"}
                                        value={values.diff_description}
                                        onChange={(e) => {
                                            setFieldValue('diff_description', e.target.value)
                                        }}
                                    />
                                    <ErrorMessage name='diff_description'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>}
                                    />
                                </div>

                            </div>
                            <div className="form-group row">
                                <div className="col-lg">
                                    <Forms.Group>
                                        <Forms.File
                                            id="file"
                                            label="Bukti Transfer"
                                            disabled={status === "SETTLE"}
                                            onChange={(event) => {
                                                setFieldValue('file', event.currentTarget.files[0]);
                                            }} />
                                        <ErrorMessage name='file'
                                            render={msg => <div style={{ color: 'red' }}>{msg}</div>} />
                                    </Forms.Group>
                                </div>
                            </div>
                            {/* )} */}

                            <button
                                type="submit"
                                style={{ display: 'none' }}
                                ref={btnCreateSettleRef}
                                onClick={() => {
                                    setButtonType("create_settle")
                                }}
                                onSubmit={() => {
                                    handleSubmit()
                                }}
                            ></button>
                            <button
                                type="submit"
                                style={{ display: 'none' }}
                                ref={btnEditDraftRef}
                                onClick={() => {
                                    setButtonType("edit_draft")
                                }}
                                onSubmit={() => {
                                    handleSubmit()
                                }}
                            ></button>
                            <button
                                type="submit"
                                style={{ display: 'none' }}
                                ref={btnEditSettleRef}
                                onClick={() => {
                                    setButtonType("edit_settle")
                                }}
                                onSubmit={() => {
                                    handleSubmit()
                                }}
                            ></button>
                            <button
                                type="submit"
                                style={{ display: 'none' }}
                                ref={btnCreateDraftRef}

                                onClick={() => {
                                    setButtonType("create_draft")
                                }}
                                onSubmit={() => {
                                    handleSubmit()
                                }}
                            ></button>

                        </Form>
                    </>
                )}

            </Formik>
        </>
    );
};


